/* @flow strict */

import * as React from 'react';
import { DELETE } from '/client/src/api';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import _ from 'lodash';
import CssPinner from '/client/src/components/csspinner';
import NProgressCustom from '/client/src/components/nProgress';

type PropsType = {
  eventId: string,
  p: {
    id: string | number,
    type: string
  },
  parts: [],
  onHandleUpdateParts: () => void,
  setEditablePart: (p: any) => void
};

const HoverSplash = (props: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const EventDetailContext = React.useContext(EventDetailContainerContext);
  const isReadonlyPermission = _.get(EventDetailContext, 'eventDetail.permission', 'Write') === 'Read';


  const type = _.toLower(props.p.type);
  const id = _.toString(props.p.id);

  const handleEdit = () => {
    if (isReadonlyPermission) return;
    props.setEditablePart({
      ...props.p,
      link_label: props.p.link_label
    });
  };

  const handleConfirmRemove = () => {
    if (isReadonlyPermission) return;
    context.handleShowSystemDialog(true, {
      systemDialogType: 'warning',
      systemDialogTitle: 'Hmmm...',
      systemDialogContent: 'Sure you want to delete this section?',
      systemDialogData: {
        setEventStatus: handleRemove,
        eventStatus: null
      },
      systemDialogCallback: () => {
        handleRemove();
      }
    });
  };

  const handleRemove = async () => {
    if (isReadonlyPermission) return;

    CssPinner(document.body, true);

    NProgressCustom(true);

    try {
      await DELETE(`/api/v1/1/splashpages/${props.eventId}/${type}/${id}`);

      context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully'
      });

      CssPinner(document.body, false);

      NProgressCustom(false);

      const newPartsData = _.filter(props.parts, (partsItem: {}): [] => {
        if (partsItem.type.toLowerCase() === type) {
          return _.toString(partsItem.id) !== _.toString(id);
        }
          return true;
      });

      props.onHandleUpdateParts(newPartsData);
    } catch (errors) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: !errors ?
          'Can\'t remove section' :
          _.map(errors, (er: {}): string => `${er.message}\n\n`)
      });

      CssPinner(document.body, false);
      NProgressCustom(false);
    }
  };

  return (
    <div
      className="splash-operate"
      data-part="edit"
      style={{ display: isReadonlyPermission ? 'none' : 'block' }}
    >
      <div className="splash-operate-buttons">
        <div className="button" onClick={handleEdit}>
          <span className="icon icon-pencil" />
          <span>edit</span>
        </div>

        <div className="button" onClick={handleConfirmRemove}>
          <span className="icon icon-trash" />
          <span>delete</span>
        </div>
      </div>
    </div>
  );
};

export default HoverSplash;
